import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeDisclaimer extends ChangeBusinessDetails {
  type: string = 'ChangeDisclaimer';
}
